import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Input from "./../../../common/input";
import getService from "../../../services/getService";
import postService from "../../../services/postService";
import { toast } from "react-toastify";
import Select from "./../../../common/select";

const SupSubCategoriesForm = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [account, setAccount] = useState({
    id: "",
    cat_id: "",
    cat_name: "",
    subcat_id: "",
    subcat_name: "",
    title: "",
  });

  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubcategoryList] = useState([]);

  const fetchCategoryList = async () => {
    const category = await getService.handleCategoryList();
    const newCategory = category.map(({ title: name, ...rest }) => ({
      name,
      ...rest,
    }));
    const filter = newCategory.filter((f) => f.name !== null || "");
    setCategoryList(filter);
  };

  const fetchSubCategoryList = async (post_category) => {
    const subcategory = await getService.handleSubCategoryList();
    const newSubCategory = subcategory.map(({ title: name, ...rest }) => ({
      name,
      ...rest,
    }));
    const filtered = newSubCategory.filter(
      (subCat) => subCat.cat_name === post_category
    );
    setSubcategoryList(filtered);
  };

  useEffect(() => {
    fetchCategoryList();
  }, []);

  useEffect(() => {
    if (account.cat_name) fetchSubCategoryList(account.cat_name);
  }, [account.cat_name]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await postService.PostSupSubCategory(account);
    } catch (error) {
      toast.error(error);
    }
  };

  const PopulateCategories = async () => {
    try {
      const Id = params.id;
      if (Id === "new") return;

      const collection = await getService.handleSuperSubCategoryList();
      const data = await getService.getData(collection, Id);
      setAccount(mapToViewModel(data));
    } catch (error) {
      toast.error(error);
    }
  };
  const mapToViewModel = ({ ...rest }) => ({ ...rest });

  useEffect(() => {
    PopulateCategories();
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    const accounts = { ...account };
    accounts[input.name] = input.value;
    setAccount(accounts);
  };

  const { title, cat_name, subcat_name } = account;

  useEffect(() => {
    if (cat_name && categoryList.length > 0) {
      const copiedCategoryList = [...categoryList];
      const categoryData = copiedCategoryList.find((c) => c.name === cat_name);
      setAccount((prevAccount) => ({
        ...prevAccount,
        cat_id: categoryData.id,
      }));
    }

    if (subcat_name && subCategoryList.length > 0) {
      const copiedSubCategoryList = [...subCategoryList];
      const subCategoryData = copiedSubCategoryList.find(
        (c) => c.name === subcat_name
      );
      setAccount((prevAccount) => ({
        ...prevAccount,
        subcat_id: subCategoryData.id,
      }));
    }
  }, [cat_name, categoryList, subcat_name, subCategoryList]);

  return (
    <>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-bd lobidrag">
            <div class="panel-heading">
              <div class="panel-title">
                <h4>Add/Update Super Sub Category </h4>
              </div>
            </div>
            <div class="panel-body">
              <form onSubmit={handleSubmit}>
                <div class="row">
                  <div className="col-md-6">
                    <Select
                      label="Category"
                      name="cat_name"
                      value={cat_name}
                      options={categoryList}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <Select
                      label="Sub Category"
                      name="subcat_name"
                      value={subcat_name}
                      options={subCategoryList}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      name="title"
                      label="Title"
                      value={title}
                      onChange={handleChange}
                    />
                  </div>

                  <div class="col-md-1 offset-md-11">
                    <button type="submit" className="btn btn-success">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SupSubCategoriesForm;
